import { HttpClientModule, provideHttpClient, withInterceptors } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { environment } from '../environments/environment';
import { readOrchestratorBaseUrl } from '../environments/orchestrator-base-url';
import { AuthModule, LogLevel, authInterceptor } from './lib/angular-auth-oidc-client-facade';
import { mobileAppHeadersInterceptor } from './interceptors/mobile-app-headers.interceptor';
import { assignmentFeedSortInterceptor } from './pages/admin/assignment-feed-sort.interceptor';

/**
 * The AuthConfigModule configures the authentication module for the application.
 *
 * This module sets up the necessary configurations for handling authentication,
 * such as authority URL, redirect URLs, client ID, and various other parameters
 * required for authentication flow.
 *
 * The module also allows for the provision of custom security storage and logger services,
 * though in this configuration they are commented out.
 *
 * Upon inclusion, this module exports the configured AuthModule to be used throughout the application.
 */
@NgModule({
   imports: [
      HttpClientModule,
      AuthModule.forRoot({
         config: {
            authority: environment.authority,
            redirectUrl: `${window.location.origin}/callback`,
            postLogoutRedirectUri: `${window.location.origin}`,
            secureRoutes: [
              environment.gateway,
              environment.authority,
              environment.api,
              readOrchestratorBaseUrl(),
              '/api/orchestrator',
              'https://masofa-yer.agro.uz',
              'https://gateway.stg-uz.6grain.com',
              'https://gateway.masofa-yer.agro.uz'
            ],
            clientId: 'crop.service',
            scope: 'openid profile email roles offline_access',
            responseType: 'code',
            silentRenew: true,
            ignoreNonceAfterRefresh: true,
            useRefreshToken: true,
            logLevel: LogLevel.None,
            customParamsAuthRequest: {
               audience: environment.audience
            }
         }
      })
   ],
   providers: [provideHttpClient(withInterceptors([mobileAppHeadersInterceptor, assignmentFeedSortInterceptor, authInterceptor()]))],
   exports: [AuthModule]
})
export class AuthConfigModule {}
